import { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { auth } from "./config/firebase";
import routes from "./config/routes";
import Center from "./components/utils/Center";
import AuthChecker from "./components/auth/AuthChecker";
import CircularProgress from "./tailwind/components/CircularProgress";
import { Nav } from "./components/Nav";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "react-hot-toast";
import { FiAlertTriangle } from "react-icons/fi";
import NotFoundPage from "./pages/error/NotFoundPage";
import ConfettiCanvas from "./components/ConfettiCanvas";
import { AnalyticsLogger } from "./components/AnalyticsLogger";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setLoading(false);
    });
  }, []);

  if (loading) {
    return (
      <Center>
        <CircularProgress />
      </Center>
    );
  }


  return (
    <div>
      <BrowserRouter basename={"/"}>
        <Nav />
        <ScrollToTop />
        <AnalyticsLogger />
        <Toaster
          position="top-right"
          toastOptions={{
            className: "bg-white text-gray-900 dark:bg-gray-800 dark:text-white rounded-lg shadow-lg",
            error: {
              icon: <FiAlertTriangle size={30} className="text-yellow-500" />,
            },
          }}
        />
        <Routes>
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                route.protected ? (
                  <AuthChecker>
                    <route.component />
                  </AuthChecker>
                ) : (
                  <route.component />
                )
              }
            />
          ))}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
